module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.931aebd3.ttf";